import { inject, injectable } from 'inversify';
import { jwtDecode } from 'jwt-decode';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { JwtLocalStorageService } from '@shared/common/network/data/service/jwt-local-storage.service';

@injectable()
export class InternalUserService {
  public constructor(
    @inject(NetworkDependencyTypes.JwtLocalStorageService)
    private readonly jwtLocalStorageService: JwtLocalStorageService,
  ) {}

  public isLoggedUserInternal(): boolean {
    const token = this.jwtLocalStorageService.get();

    if (!token) {
      return false;
    }

    try {
      const payload = jwtDecode<Record<string, unknown>>(token);

      return payload['login-as'] === true;
    } catch {
      return false;
    }
  }
}
